import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostData,
  type UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostError,
  type UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostResponse,
  uploadImageV1WorkspacesWorkspaceIdAssetsImagesPost,
} from '../../generated';

export type UploadImageMutationVariables = UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostData['path'] &
  UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostData['body'];

export type UploadImageMutation = UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostResponse;

export const useUploadImageMutation = <
  TError = UploadImageV1WorkspacesWorkspaceIdAssetsImagesPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<UploadImageMutation, TError, UploadImageMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<UploadImageMutation, TError, UploadImageMutationVariables, TContext>({
    mutationKey: ['UploadImage'],
    mutationFn: async ({ workspace_id, ...body }: UploadImageMutationVariables) => {
      const { data } = await uploadImageV1WorkspacesWorkspaceIdAssetsImagesPost({
        path: { workspace_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useUploadImageMutation.fetcher = (
  { workspace_id, ...body }: UploadImageMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await uploadImageV1WorkspacesWorkspaceIdAssetsImagesPost({
      path: { workspace_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
